import AxiosConfig from '@/config/axios-config'

export default {

  pesquisar (texto, tipo, empresa, pagina, limite, planosIdsDoUsuario) {
    if (!pagina) {
      pagina = 1
    }

    if (!limite) {
      limite = 10
    }

    return AxiosConfig
      .jalekoBuscaAPI()
      .get('/v3/busca', { params: { texto: texto, tipo: tipo, pagina: pagina, limite: limite, empresa: empresa, plano: planosIdsDoUsuario } })
      .then(response => response.data)
  }

}
